import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepeatOn = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_764_3468)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.99996 15.3333C1.63329 15.3333 1.3194 15.2028 1.05829 14.9417C0.797182 14.6805 0.666626 14.3667 0.666626 14V1.99999C0.666626 1.63332 0.797182 1.31943 1.05829 1.05832C1.3194 0.797212 1.63329 0.666656 1.99996 0.666656H14C14.3666 0.666656 14.6805 0.797212 14.9416 1.05832C15.2027 1.31943 15.3333 1.63332 15.3333 1.99999V14C15.3333 14.3667 15.2027 14.6805 14.9416 14.9417C14.6805 15.2028 14.3666 15.3333 14 15.3333H1.99996ZM4.66663 14.6667L5.59996 13.7L4.56663 12.6667H12.6666V8.66666H11.3333V11.3333H4.56663L5.59996 10.3L4.66663 9.33332L1.99996 12L4.66663 14.6667ZM3.33329 7.33332H4.66663V4.66666H11.4333L10.4 5.69999L11.3333 6.66666L14 3.99999L11.3333 1.33332L10.4 2.29999L11.4333 3.33332H3.33329V7.33332Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_764_3468",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgRepeatOn);
export default ForwardRef;
